import { useState, useEffect } from 'react'
import NewsCard from '../../components/NewsCard'
import LoadingNewsCard from '../../components/LoadingNewsCard'
import CourseCard from '../../components/CourseCard'
import Carusel from '../../components/Carusel'
import TimeLine from '../../components/TimeLine'
import ContactCard from '../../components/ContactCard'
import type Post from '../../types/post'
import { useFetch } from '../../hooks/useFetch'
import { BEUrl } from '../../types'
import type { CourseDto, CourseApiDto } from '../../types'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import MapComponent from '../../components/Map'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Risa from '../../assets/images/Instruktori/Ríša-min.JPG'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Gabina from '../../assets/images/Instruktori/Gabča-min.JPG'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Zdenek from '../../assets/images/Instruktori/Zdeněk-min.JPG'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Michal from '../../assets/images/Instruktori/Michal Maly.jpg'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import Hromadna from '../../assets/images/Instruktori/Hromadná-min.JPG'
import LogoShellma from '../../assets/images/Loga/PersonalLogo.png'
import LogoGympl from '../../assets/images/Loga/GymplLogo.png'
import LogoMaro from '../../assets/images/Loga/maroIcon.png'
import LogoGloryFightClub from '../../assets/images/Loga/GloryFightClub.png'
import { useMediaQuery } from 'react-responsive'
import { Link } from 'react-scroll'
import Button from '../../components/common/Button'
import { Modal } from '@mui/material'
import MobileFooter from '../../components/MobileFooter'
import Footer from '../../components/Footer'
import { fallbackCourses, convertApiCoursesToCourseDtos } from '../../data/courses'
import api from '../../api'

const Erko: React.FC = () => {
    const { data, isLoading, error } = useFetch<Post>(BEUrl.posts)
    const isLargeScreen = useMediaQuery({ minWidth: 1024 })
    const [isModalOpen, setIsModalOpen] = useState(false)

    // Courses state - use fallback while loading or on error
    const [courses, setCourses] = useState<CourseDto[]>(fallbackCourses)

    // Fetch courses from API with fallback to hardcoded data
    useEffect(() => {
        api.get<CourseApiDto[]>('courses')
            .then(res => {
                if (Array.isArray(res.data)) {
                    const convertedCourses = convertApiCoursesToCourseDtos(res.data)
                    setCourses(convertedCourses)
                }
            })
            .catch(() => {
                // On error, keep using fallback courses
            })
    }, [])

    // Check if current time is Monday-Friday between 14:00 and 22:00
    const isBusinessHours = (): boolean => {
        const now = new Date()
        const dayOfWeek = now.getDay() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
        const hour = now.getHours()

        // Monday (1) to Friday (5) between 14:00 and 22:00
        return dayOfWeek >= 1 && dayOfWeek <= 5 && hour >= 14 && hour < 22
    }

    const showPhoneNumber = isBusinessHours()

    return (
        <main className='overflow-hidden'>
            {/* Modal for phone number */}
            <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '90vw',
                        maxWidth: 400,
                        backgroundColor: '#241823',
                        color: '#FFF6FF',
                        padding: 32,
                        borderRadius: 20,
                        boxShadow: '0px 0px 30px rgba(191, 61, 201, 0.8)',
                        outline: 'none',
                        border: 'none',
                    }}
                >
                    <div className='absolute text-2xl text-gray-300 right-4 top-4 cursor-pointer'>
                        <span onClick={() => setIsModalOpen(false)}>×</span>
                    </div>
                    <h3 className='text-secondary text-3xl font-bold text-center mb-4 not-italic underline'>
                        Volat pondělí až pátek po 14. hodině
                    </h3>
                    <div className='flex flex-col items-center justify-center text-center'>
                        <a href='tel:724 790 187' className='text-secondary text-xl text-center mb-6 w-fit'>
                            724 790 187
                        </a>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className='w-full bg-primary text-secondary px-4 py-2 rounded-lg font-bold hover:bg-primary/80 transition-colors'
                        >
                            Zavřít
                        </button>
                    </div>
                </div>
            </Modal>
            <header className='w-screen container mx-auto bg-background mt-16' id='home'>
                <section className='flex flex-col md:flex-row items-center justify-between h-full px-4'>
                    <div className='z-10 py-7 md:pt-0'>
                        <h1 className='text-secondary text-l md:text-2xl font-bold'>Richard Melicher</h1>
                        <h2 className='text-secondary text-4xl md:text-8xl font-bold mt-2'>
                            Autoškola <span className='text-primary'>eRko</span>
                        </h2>
                        <p className='text-secondary text-2xl md:text-4xl font-bold mt-4 mb-2'>I autoškolu můžete mít rádi...</p>
                        <div className='flex flex-row space-x-3'>
                            <Link activeClass='active' to='courses' spy={true} smooth={true} offset={-200} duration={500}>
                                <Button title='Vybrat kurz' />
                            </Link>
                            <Link activeClass='active' to='contact' spy={true} smooth={true} offset={-200} duration={1000}>
                                <Button title='Kontakt' variant='secondary' />
                            </Link>
                        </div>
                    </div>
                    <div className='flex items-center justify-center w-full h-[55vh] md:w-[600px] md:h-[600px] relative'>
                        <img className='object z-10 rounded-3xl' src={Hromadna} alt='Car' />
                        <div
                            style={{
                                background: 'radial-gradient(circle, rgba(255,0,251,1) 0%, rgba(255,0,251,0) 30%)',
                                width: '1750px',
                                height: '1750px',
                                zIndex: 0,
                            }}
                            className='absolute'
                        />
                    </div>
                </section>
            </header>

            <section
                className='w-screen container mx-auto mt-36 flex flex-col items-center'
                id='courses'
                aria-labelledby='courses-heading'
            >
                <h2 id='courses-heading' className='text-secondary text-6xl font-bold text-center z-10'>
                    Co nabízíme
                </h2>
                <div className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-16 relative mt-12 mb-8 items-center`}>
                    <div
                        style={{
                            background:
                                'radial-gradient(50% 50% at 50% 50%, rgba(191, 61, 201, 0.3) 0%, rgba(82, 26, 86, 0.128125) 59.38%, rgba(0, 0, 0, 0) 100%) ',
                            width: '1888px',
                            height: '1896px',
                            top: '-1000px',
                            left: '-1000px',
                        }}
                        className='absolute'
                    />
                    <div
                        style={{
                            background:
                                'radial-gradient(50% 50% at 50% 50%, rgba(191, 61, 201, 0.3) 0%, rgba(82, 26, 86, 0.128125) 59.38%, rgba(0, 0, 0, 0) 100%) ',
                            width: '1888px',
                            height: '1896px',
                            right: '-1000px',
                            top: '-700px',
                        }}
                        className='absolute'
                    />
                    {courses.map((course, index) => (
                        <CourseCard key={index} course={course} />
                    ))}
                </div>
                <Link activeClass='active' to='tutorial' spy={true} smooth={true} offset={-200} duration={1000} className='z-10'>
                    <Button title='Mám vybráno!' />
                </Link>
            </section>

            <section
                className='w-screen container mx-auto mt-36 relative flex flex-col items-center'
                id='whatsNew'
                aria-labelledby='news-heading'
            >
                <div
                    style={{
                        background:
                            'radial-gradient(50% 50% at 50% 50%, rgba(191, 61, 201, 0.3) 0%, rgba(82, 26, 86, 0.128125) 59.38%, rgba(0, 0, 0, 0) 100%) ',
                        width: '1888px',
                        height: '1896px',
                        top: '-500px',
                        left: '-1000px',
                        zIndex: -1,
                    }}
                    className='absolute'
                />
                {(!error || isLoading) && (
                    <>
                        <h2 id='news-heading' className='text-secondary text-6xl font-bold text-center mb-6'>
                            Co je nového
                        </h2>
                        <article className='flex flex-wrap justify-center'>
                            {!isLoading && (
                                <NewsCard
                                    data={{
                                        title: 'Tipy pro začátečníky',
                                        description:
                                            'Na odkazech níže najdete oficiální testy Ministerstva dopravy ČR a praktické rady pro začínající i zkušené řidiče.',
                                        created: new Date().toISOString(),
                                        uuid: '1',
                                        buttonLink: 'https://etesty2.mdcr.cz/',
                                        buttonText: 'E-Testy',
                                        buttonLink2: 'http://www.ibesip.cz',
                                        buttonText2: 'BESIP',
                                    }}
                                />
                            )}
                            {isLoading
                                ? [1, 2, 3, 4].map((item) => <LoadingNewsCard key={item} />)
                                : data && data.map((data: Post) => <NewsCard key={data.uuid} data={data} />)}
                        </article>
                    </>
                )}
            </section>

            <section
                className='w-screen min-h-[500px] mt-44 container mx-auto flex flex-col lg:flex-row relative px-4 space-y-6'
                id='aboutUs'
                aria-labelledby='about-heading'
            >
                <div
                    style={{
                        background:
                            'radial-gradient(50% 50% at 50% 50%, rgba(191, 61, 201, 0.3) 0%, rgba(82, 26, 86, 0.128125) 59.38%, rgba(0, 0, 0, 0) 100%) ',
                        width: '1888px',
                        height: '1896px',
                        top: '-750px',
                        right: '-1000px',
                        zIndex: -35000,
                    }}
                    className='absolute'
                />
                <div className='w-full lg:w-2/3 min-h-64'>
                    <h2 id='about-heading' className='text-secondary text-6xl font-bold mb-6'>
                        Něco málo o nás!
                    </h2>
                    <div className='flex flex-col space-y-6'>
                        <p className='text-secondary text-xl'>
                            ✓ Autoškola ERKO v Chomutově nabízí kurzy pro získání řidičského oprávnění skupiny B, B+E, A1, A2 a A.
                        </p>
                        <p className='text-secondary text-xl'>✓ Teoretická výuka probíhá v učebně Městského gymnázia Jirkov.</p>
                        <p className='text-secondary text-xl'>
                            ✓ Praktický výcvik probíhá na vozidlech Škoda Rapid Spaceback, Škoda Fabia III a Škoda Yeti, KTM Duke
                            125, Honda CB125R, CF MOTO 300NK, Honda CB500 Hornet a Honda CB750 Hornet.
                        </p>
                        <p className='text-secondary text-xl'>✓ Jezdíme převážně na území měst Chomutov a Jirkov</p>
                        <p className='text-secondary text-xl'>
                            ✓ ERKO má zkušené instruktory a nabízí flexibilní plánování výuky a výcviku.
                        </p>
                        <p className='text-secondary text-xl'>
                            ✓ ERKO nabízí i kurz pro vrácení řidičského průkazu a kondiční jízdy pro držitele řidičského
                            oprávnění.
                        </p>

                        <div className='flex flex-row space-x-5'>
                            <Link
                                activeClass='active'
                                to='courses'
                                spy={true}
                                smooth={true}
                                offset={-200}
                                duration={1000}
                                className='z-10'
                            >
                                <Button title='Chci si vybrat kurz!' />
                            </Link>
                            <Link
                                activeClass='active'
                                to='contact'
                                spy={true}
                                smooth={true}
                                offset={-200}
                                duration={1000}
                                className='z-10'
                            >
                                <Button title='Kontakt' variant='secondary' />
                            </Link>
                        </div>
                    </div>
                </div>
                <aside className='w-full lg:w-1/3 min-h-64'>
                    <Carusel />
                </aside>
            </section>

            <section
                className='w-screen container mx-auto mt-36 relative flex flex-col items-center'
                id='team'
                aria-labelledby='team-heading'
            >
                <h2 id='team-heading' className='text-secondary text-6xl font-bold text-center mb-12'>
                    Náš tým
                </h2>
                <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-16 relative mb-12 items-center'>
                    <ContactCard
                        name='Richard Melicher'
                        img={Risa}
                        position='Učitel teoretické výuky a praktického výcviku'
                        description='Nevim'
                    />
                    <ContactCard
                        name='Gabriela Melicherová'
                        img={Gabina}
                        position='Učitelka teoretické výuky a praktického výcviku'
                        description='Nevim'
                    />
                    <ContactCard name='Zdeněk Buchta' img={Zdenek} position='Učitel praktického výcviku' description='Nevim' />
                    <ContactCard
                        name='Michal Malý'
                        img={Michal}
                        position='Učitel teoretické výuky a praktického výcviku'
                        description='Nevim'
                        imageScale={3.2}
                        imageOffsetX='-15%'
                        imageOffsetY='30%'
                    />
                </div>
            </section>

            <section className='w-screen container mx-auto mt-36 flex flex-col' id='tutorial' aria-labelledby='tutorial-heading'>
                <h2 id='tutorial-heading' className='text-secondary text-6xl font-bold text-center mb-12'>
                    Jak se přihlásit?
                </h2>
                <TimeLine />
            </section>

            <section className='w-screen mx-auto max-w-[1920px] mt-36 flex flex-col-reverse lg:flex-col relative'>
                <MapComponent />
                {isLargeScreen ? (
                    <address
                        className='w-full lg:w-2/3 lg:absolute right-[-100px] top-[-12px]'
                        style={{ height: 'calc(100% + 18px)' }}
                        id='contact'
                    >
                        <div className={`w-full h-full ${isLargeScreen ? 'trapezoid' : ''}`}>
                            <div
                                className={`w-full h-full flex flex-row lg:flex-col lg:items-center pt-[10px] ${
                                    isLargeScreen ? 'innerTrapezoid' : ''
                                }`}
                            >
                                <div className='text-secondary text-[3.3vw] 2xl:text-[60px] font-bold lg:pl-[170px] '>
                                    Autoškola <span className='text-primary'>eRko</span>
                                </div>

                                <div className='lg:pl-[160px] xl:pl-[240px]'>
                                    <div className='text-secondary text-[2vw] 2xl:text-[40px] font-bold mt-2'>Kontakt</div>
                                    <div className='text-secondaryDark text-[1vw] 2xl:text-[20px]  font-bold '>
                                        <span className='text-secondary'>Jméno:</span>
                                        Richard Melicher
                                    </div>
                                    <div className='text-secondaryDark text-[1vw] 2xl:text-[20px] font-bold '>
                                        <span className='text-secondary'>Učebna teorie:</span> Gymnázium Jirkov, Mostecká 35,
                                        Jirkov
                                    </div>
                                    <div className='text-secondaryDark text-[1vw] 2xl:text-[20px]  font-bold '>
                                        <span className='text-secondary'>Sídlo firmy:</span> Jasmínová 5893, 430 04 Chomutov
                                    </div>
                                    <div className='text-secondaryDark text-[1vw] 2xl:text-[20px]  font-bold '>
                                        <span className='text-secondary'>Telefon pro nové žadatele:</span>{' '}
                                        {showPhoneNumber ? (
                                            <a href='tel:724 790 187'>724 790 187</a>
                                        ) : (
                                            <button
                                                onClick={() => setIsModalOpen(true)}
                                                className='text-primary underline hover:text-primary/80 transition-colors'
                                            >
                                                klikni zde
                                            </button>
                                        )}{' '}
                                        (<span className='text-secondary not-italic underline'>po-pá po 14. hodině</span>)
                                    </div>
                                    <div className='text-secondaryDark text-[1vw] 2xl:text-[20px]  font-bold'>
                                        <span className='text-secondary'>Email:</span>{' '}
                                        <a href='mailto:autoskolaerko@seznam.cz'> autoskolaerko@seznam.cz</a>
                                    </div>
                                </div>
                                <div className='self-start lg: pl-[230px] xl:pl-[260px] w-[80%]'>
                                    <h2 className='text-secondary text-[2vw] 2xl:text-[40px] font-bold mt-2'>Spolupracujeme</h2>
                                    <nav className='flex w-full justify-between flex-wrap space-x-1'>
                                        <img
                                            src={LogoShellma}
                                            alt='LogoShellma'
                                            width='130'
                                            height='130'
                                            loading='lazy'
                                            className='object-contain cursor-pointer'
                                            onClick={() => window.open('https://www.shellma.dev/', '_blank')}
                                        />
                                        <img
                                            src={LogoGympl}
                                            alt='Městské gymnázium a Základní škola Jirkov'
                                            width='130'
                                            height='130'
                                            loading='lazy'
                                            className='object-contain cursor-pointer'
                                            onClick={() => window.open('http://web.gympljirkov.cz/', '_blank')}
                                        />
                                        <img
                                            src={LogoMaro}
                                            alt='MARO Kralovice'
                                            width='130'
                                            height='130'
                                            loading='lazy'
                                            className='object-contain cursor-pointer'
                                            onClick={() => window.open('https://www.maro-kralovice.cz/', '_blank')}
                                        />
                                        <img
                                            src={LogoGloryFightClub}
                                            alt='Glory Fight Club'
                                            width='130'
                                            height='130'
                                            loading='lazy'
                                            className='object-contain cursor-pointer'
                                            onClick={() => window.open('https://gloryfightclub.club/', '_blank')}
                                        />
                                        {/* <img
                                            src={LogoLenkaC}
                                            alt='PhDr. Lenka Čermáková'
                                            width='130'
                                            height='130'
                                            loading='lazy'
                                            className='object-cover cursor-pointer'
                                            onClick={() => window.open('https://www.lenkacermakova.eu/', '_blank')}
                                        /> */}
                                        <div
                                            className='w-[150px] h-[120px] bg-secondary p-2 rounded-xl shadow-md shadow-primary cursor-pointer'
                                            onClick={() => window.open('https://www.lenkacermakova.eu/', '_blank')}
                                        >
                                            PhDr. Lenka Čermáková{' '}
                                            <p className='text-sm text-gray-500'>akreditovaný dopravní psycholog</p>
                                        </div>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </address>
                ) : (
                    <MobileFooter />
                )}
            </section>
            <Footer />
        </main>
    )
}

export default Erko
